import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Configuration } from '../constants/config';

import { MyApp } from './app.component';
import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { InventoryPage } from '../pages/inventory/inventory';
import { CategoriesPage } from '../pages/categories/categories';
import { PosTabsPage } from '../pages/pos-tabs/pos-tabs';
import { PosPage } from '../pages/pos/pos';
import { PaymentPage } from '../pages/payment/payment';
import { PaymentConfirmationPage } from '../pages/payment-confirmation/payment-confirmation';
import { ReportsPage } from '../pages/reports/reports';
import { SettingsPage } from '../pages/settings/settings';

import { AuthServiceProvider } from '../providers/auth-service/auth-service';
import { InventarioServiceProvider } from '../providers/inventario-service/inventario-service';
import { CategoryServiceProvider } from '../providers/category-service/category-service';
import { PaymentServiceProvider } from '../providers/payment-service/payment-service';
import { SettingsServiceProvider } from '../providers/settings-service/settings-service';
import { EmployeeServiceProvider } from '../providers/employee-service/employee-service';
import { InvoiceServiceProvider } from '../providers/invoice-service/invoice-service';
import { ReportsServiceProvider } from '../providers/reports-service/reports-service';

@NgModule({
    declarations: [
        MyApp,
        Configuration,
        LoginPage,
        HomePage,
        InventoryPage,
        CategoriesPage,
        PosTabsPage,
        PosPage,
        PaymentPage,
        PaymentConfirmationPage,
        ReportsPage,
        SettingsPage
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp),
        HttpModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        LoginPage,
        HomePage,
        InventoryPage,
        CategoriesPage,
        PosTabsPage,
        PosPage,
        PaymentPage,
        PaymentConfirmationPage,
        ReportsPage,
        SettingsPage
    ],
    providers: [
        StatusBar,
        Configuration,
        SplashScreen,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        AuthServiceProvider,
        InventarioServiceProvider,
        CategoryServiceProvider,
        PaymentServiceProvider,
        SettingsServiceProvider,
        EmployeeServiceProvider,
        InvoiceServiceProvider,
        ReportsServiceProvider,
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts